import router from "../../router";
const tagsViewStore = {
    state: {
        // 打开的标签页
        visitedViews: [],
    },
    mutations: {
        // 设置可见标签页数组
        SET_VISITED_VIEWS(state, data) {
            state.visitedViews = data
        },
        // 添加可见标签页
        ADD_VISITED_VIEW: (state, view) => {
            if (state.visitedViews.some(v => (v.menuName === view.menuName))) return;
            state.visitedViews.push(view)
        },
        // 删除可见标签页
        DEL_VISITED_VIEW: (state, view) => {
            // 删除当前标签页
            for (const [i, v] of state.visitedViews.entries()) {
                if (v.menuName === view.menuName) {
                    state.visitedViews.splice(i, 1)
                    break
                }
            }
            // 关闭当前标签页后跳转至上一个标签页
            const latestView = state.visitedViews.slice(-1)[0];
            if (latestView) {
                router.push({ path: latestView.path, query: latestView.query });
            }
        },
        // 关闭所有标签页,保留第一项
        DEL_ALL_VISITED_VIEWS: state => {
            const firstView = state.visitedViews.slice(0, 1);
            state.visitedViews = firstView;
            router.push({ path: firstView[0].path, query: firstView[0].query });
        },
        // 关闭其他
        DEL_OTHERS_VISITED_VIEWS: (state, view) => {
            state.visitedViews = state.visitedViews.filter(v => {
                router.push({ path: view.path, query: view.query });
                return v.menuName === view.menuName
            })
        },

    },
    actions: {}
}

export default tagsViewStore